import { EmptyTemplate } from "../EmptyTemplate";
import noResultsImage from "../../../assets/Illustration_NoResults.svg";

// ************************************ //
// ******* DEFAULT TABLE VALUES ******* //
// ******* DEFAULT TABLE VALUES ******* //
// ******* DEFAULT TABLE VALUES ******* //
// ************************************ //

// Nombre de la clase de la tabla
const classNametable: string = 'basic-table-style';

// Nombre de clase obligatorio para organizar las columnas
const obligatoryTableClass = 'p-datatable-resizable';

// Columnas ajustables
const resizableColumns: boolean = true;

// Plantilla paginador
const currentPageReportTemplate = (t: Function) => t(
  "ConsoleTranslations.rowsPaginatorTemplateLabel"
);

// Plantilla para incluir texto de items en el paginador
const paginatorRight = (t: Function) => t(
  'ConsoleTranslations.itemsTextDatatableLabel'
);

// Traducción del mensaje de tabla vacía
const emptyMessageTemplate: any = (t:Function, idEmptyTemplate?:string) => EmptyTemplate ({
  image: noResultsImage,
  text: t('Catalogue.emptyDataTableMessage'),
  id: idEmptyTemplate});

// Número de filas a mostrar
const rowsNumber: number = 10;

// Alto de fila
const sizeEnum: 'large' | 'normal' | 'small' = 'normal';

// Tabla scroll con scrolling
const scrollable: boolean = true;

// Dirección del scroll
const scrollDirectionEnum: 'both' | 'horizontal' | 'vertical' = 'horizontal';

// Lugar de almacenamiento del estado de la tabla
const stateStorageEnum: 'custom' | 'local' | 'session' = 'session';

// Nombre de la clase del estado de la tabla
const stateKeyLabel: string = 'filters-table';

// Arreglo de rango de registros a mostrar en la tabla
const rowsPerPageOptions = [10, 20, 50];


// ************************************* //
// ******* DEFAULT COLUMN VALUES ******* //
// ******* DEFAULT COLUMN VALUES ******* //
// ******* DEFAULT COLUMN VALUES ******* //
// ************************************* //
// Ancho máximo de la columna
const columnMaxWidth = 'max(18.75rem,100%)';
const headerStyle = {
  // width: '100%',
};

// Estilo de la columna tanto header/body
const style = {
  whiteSpace: 'normal',
}

// Nombre de la clase de las celdas de Acciones
const classNameActions: string = 'general-actions-column';

// Nombre de clase obligatorio para modificar estilos dentro de las columnas
const obligatoryColumnClass = 'general-content-column';



// ******* TABLE FUNCTION ******* //
// ******* TABLE FUNCTION ******* //
// ******* TABLE FUNCTION ******* //
export const tableBasicProps = ( t: Function, {classBackgroundDynamic, fieldBackgroundDynamic, criteriaBackgroundDynamic}:
  {classBackgroundDynamic?: string, fieldBackgroundDynamic: string, criteriaBackgroundDynamic: string},
  customProps?: {
    className?: string,
    emptyMessage?: string,
    rows?: number,
    size?: 'large' | 'normal' | 'small',
    scrollDirection?: 'both' | 'horizontal' | 'vertical',
    stateStorage?: 'custom' | 'local' | 'session',
    stateKey?: string,
    hasEmptyTemplate?: boolean,
    idEmptyTemplate?: string,
  }
) => ({
  className: `${!!customProps?.className ? (customProps.className + ' ') : ''}${classNametable} ${obligatoryTableClass}`,
  rowClassName: (data:any) => {
    return data[fieldBackgroundDynamic] === criteriaBackgroundDynamic
        ? { [classBackgroundDynamic ?? 'basic-table-row-background']: true } : { 'datatable-original-background': true }
  },
  resizableColumns,
  currentPageReportTemplate: currentPageReportTemplate(t),
  paginatorRight: paginatorRight(t),
  emptyMessage: !!customProps?.emptyMessage
    ? t(customProps?.emptyMessage)
    : (!!customProps?.hasEmptyTemplate
      ? () => emptyMessageTemplate(t, customProps?.idEmptyTemplate)
      : t('TableActions.emptyMessage')
    ),
  rows: customProps?.rows ?? rowsNumber,
  size: customProps?.size ?? sizeEnum,
  scrollable,
  scrollDirection: customProps?.scrollDirection ?? scrollDirectionEnum,
  stateStorage: customProps?.stateStorage ?? stateStorageEnum,
  stateKey: customProps?.stateKey ?? stateKeyLabel,
  rowsPerPageOptions,
});


// ******* COLUMN FUNCTION ******* //
// ******* COLUMN FUNCTION ******* //
// ******* COLUMN FUNCTION ******* //
export const columnBasicProps = (
  { col }: { col:any },
  customProps?: {
    className?: string,
  }
) => ({
  headerStyle: {
    ...headerStyle,
    justifyContent: col?.field === 'actions' ? 'center' : undefined,
    maxWidth: (col?.field === 'actions') ? 'min-content' : columnMaxWidth,
  },
  style: {
    ...style,
    boxShadow: (col?.field === "actions")
      ? 'rgb(230 230 230 / 55%) -2px 0px, rgb(235 235 235 / 55%) -3px 0px, rgb(240 240 240 / 45%) -5px 0px'
      : undefined,
    maxWidth: (col?.field === 'actions') ? 'min-content' : columnMaxWidth,
    minWidth: (col?.field === 'actions') ? '8.5rem' : '10rem',
  },
  className: `${!!customProps?.className ? (customProps.className + ' ') : ''}
    ${col?.field === 'actions' ? (classNameActions + ' ') : ''}${obligatoryColumnClass}`,
})